export default "__VITE_ASSET__56a38f84__"